import { useCallback, useEffect, useState } from 'react'

export interface OrderFieldsDraft {
  shipDate: string
  shipTime: string
  track: string
}

export const ORDER_FIELDS_SAVE_ERROR = 'Не удалось сохранить дату, время или трек. Проверьте связь и измените поле ещё раз.'

const SAVE_DELAY_MS = 600

/** Saves the drawer fields only after the owner edits them; suggested defaults stay unsaved. */
export function useOrderFieldsAutosave({ orderId, fields, save }: {
  orderId: number | null
  fields: OrderFieldsDraft
  save: (orderId: number, fields: OrderFieldsDraft) => Promise<void>
}): { markEdited: () => void; saveError: string } {
  const [editedOrderId, setEditedOrderId] = useState<number | null>(null)
  const [saveError, setSaveError] = useState('')
  const { shipDate, shipTime, track } = fields

  useEffect(() => {
    setEditedOrderId(null)
    setSaveError('')
  }, [orderId])

  useEffect(() => {
    if (orderId === null || editedOrderId !== orderId) return
    let current = true
    const timer = setTimeout(() => {
      save(orderId, { shipDate, shipTime, track }).then(
        () => { if (current) setSaveError('') },
        () => { if (current) setSaveError(ORDER_FIELDS_SAVE_ERROR) },
      )
    }, SAVE_DELAY_MS)
    return () => {
      current = false
      clearTimeout(timer)
    }
  }, [orderId, editedOrderId, shipDate, shipTime, track, save])

  const markEdited = useCallback(() => setEditedOrderId(orderId), [orderId])
  return { markEdited, saveError }
}
